// extracted by mini-css-extract-plugin
export default {"general":"General_general__4KRCu"};